/**
 * Track page views for Google Analytics 4 (SPA).
 * Call this when the route changes. Replace G-XXXXXXXXXX with your GA4 Measurement ID.
 */
export function trackPageView(path) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path || window.location.pathname,
      page_title: document.title,
    })
  }
}
